import { createRoot } from 'react-dom/client';

import { API_MOCK_ENABLED } from '@/constants';
import { reloadOnPreloadError } from '@/utils/reloadOnPreloadError';

import { AppWrapper } from './AppWrapper';

reloadOnPreloadError();

if (API_MOCK_ENABLED) {
  (async () => {
    const { server } = await import('./mocks/devServer');
    server.start();
  })();
}

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<AppWrapper />);
} else {
  console.error('Root element not found!');
}
